import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { CustomEase } from "gsap/CustomEase"

gsap.registerPlugin(ScrollTrigger, CustomEase)

let stickyFeatureMatchMedia = []

export default function initStickyFeatures() {
	stickyFeatureMatchMedia.forEach((mm) => mm.revert())
	stickyFeatureMatchMedia = []

	const stickyFeatures = document.querySelectorAll("[data-sticky-features]")

	stickyFeatures.forEach(container => {

		// MARK: Get DOM Elements
		const visuals = Array.from(container.querySelectorAll("[data-sticky-features-visual]"))
		const items = Array.from(container.querySelectorAll("[data-sticky-features-item]"))
		const progress = container.querySelector("[data-sticky-features-progress]")
		const paginationCurrent = container.querySelector("[data-sticky-features-pagination-current]")
		const paginationTotal = container.querySelector("[data-sticky-features-pagination-total]")
		const triggersContainer = container.querySelector("[data-sticky-features-triggers]")

		if (!progress || !paginationCurrent || !paginationTotal || !triggersContainer) return

		paginationCurrent.replaceChildren()
		triggersContainer.replaceChildren()
		
		CustomEase.create("textEase", "0.4, 0, 0.2, 1")
		
		if (visuals.length !== items.length) {
			console.warn("[initStickyFeatures] visuals and items count do not match:", {
				visuals: visuals.length,
				items: items.length,
				wrap: container
			})
		}
		
		const count = Math.min(visuals.length, items.length)
		if(count < 1) return

		// MARK: Create trigger and pagination elements
		paginationTotal.textContent = ('0' + count).slice(-2)
		
		items.forEach((item,index) => {

			const trigger = document.createElement('div')
			trigger.classList.add("sticky-features__triggers-item")
			trigger.setAttribute("data-sticky-features-trigger", index)
			triggersContainer.appendChild(trigger)

			const paginationNumber = document.createElement('div')
			paginationNumber.classList.add("sticky-features__pagination-index")
			paginationNumber.textContent = ('0' + (index + 1)).slice(-2)
			paginationCurrent.appendChild(paginationNumber)

		})

		let currentIndex = 0

		// MARK: Update pagination element
		function updatePagination(index) {
			paginationCurrent.style.transform = 'translateY(' + (((100 / count) * index) * -1) + '%)'
		}

		function playTransition(fromIndex, toIndex) {

			if (fromIndex === toIndex) return

			const tl = gsap.timeline({
				defaults: {
					duration: 0.6,
					ease: "textEase",
					overwrite: "auto"
				}
			})

			if (fromIndex > toIndex) {

				tl
					.to(visuals[fromIndex], { autoAlpha: 0, scale: 1.03 }, 0)
					.to(items[fromIndex], { autoAlpha: 0, y: 60 }, 0)
					.fromTo(visuals[toIndex], { autoAlpha: 0, scale: 1.03 }, { autoAlpha: 1, scale: 1 }, 0)
					.fromTo(items[toIndex], { autoAlpha: 0, y: -60 }, { autoAlpha: 1, y: 0 }, 0.1)
			} else {

				tl
					.to(visuals[fromIndex], { autoAlpha: 0, scale: 1.03 }, 0)
					.to(items[fromIndex], { autoAlpha: 0, y: -60 }, 0)
					.fromTo(visuals[toIndex], { autoAlpha: 0, scale: 1.03 }, { autoAlpha: 1, scale: 1 }, 0)
					.fromTo(items[toIndex], { autoAlpha: 0, y: 60 }, { autoAlpha: 1, y: 0 }, 0.1)
			}

			currentIndex = toIndex
		}

		// MARK: Scrolltrigger
		let mm = gsap.matchMedia()
		stickyFeatureMatchMedia.push(mm)

		mm.add("(min-width: 960px)", () => {

			// Initial state
			gsap.set(visuals, {
				autoAlpha: 0
			})

			gsap.set(items, {
				autoAlpha: 0
			})

			gsap.set([visuals[0], items[0]], {
				autoAlpha: 1
			})

			updatePagination(0)

			const stickyScrollTrigger = ScrollTrigger.create({
				trigger: container,
				start: "top top",
				end: "bottom bottom",
				scrub: 1,
				invalidateOnRefresh: true,
				onUpdate: self => {

					const index = Math.min(
						count - 1,
						Math.floor(self.progress * count)
					)

					updatePagination(index)
					playTransition(currentIndex, index)

					gsap.to(progress, {
						scaleX: self.progress,
						ease: "none",
						overwrite: true
					})
				}
			})

			return () => {
				stickyScrollTrigger.kill()
				gsap.set([...visuals, ...items], { clearProps: "opacity,visibility,transform" })
			}
		})

	})
}
